var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FunctionalGridViewFieldArray',_vm._g({attrs:{"field":_vm.field,"value":_vm.value,"row":_vm.row,"selected":_vm.selected},on:{"show":_vm.showModal}},_vm.$listeners),[(_vm.needsModal)?_c(_vm.modalComponent,{ref:"modal",tag:"component",attrs:{"read-only":true,"value":_vm.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }